<template>
  <div class="container">
    <button type="button" class="btn btn-link open-btn" data-toggle="modal" :data-target="`#help${ this.id }`">
      <i class="fa fa-question-circle"/>
    </button>

    <div class="modal inmodal" :id="`help${ this.id }`" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content animated fadeIn">
          <div class="modal-header">

            <button type="button" class="close" data-dismiss="modal" ref="btnClose">
              <span aria-hidden="true">&times;</span><span class="sr-only"></span>
            </button>

            <h4 class="modal-title">{{ title }}</h4>
          </div>

          <div class="modal-body">
            <slot/>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              Fechar
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      id: { type: String, default: '' },
      title: { type: String, default: 'Ajuda' }
    }
  }
</script>

<style scoped >
  .container {
    display: inline-block;
    padding: 0;
  }
  .open-btn, .open-btn:focus, .open-btn:active, .open-btn:active:focus {
    margin-bottom: 0;
    outline: none;
  }
  .modal {
    margin-top: 100px;
  }
  .modal-header {
    border-bottom: none;
  }
  .modal-body {
    background-color: inherit;
    font-weight: normal;
    font-size: 14px;
    text-align: justify;
    text-indent: 25px;
  }
  .modal-footer {
    padding: 10px 15px;
    border-top: none;
  }
  .modal-footer .btn {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Help.vue